import React, { useState, Component } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Cuándo notaré diferencia?',
  answer: 'Los resultados varían según cada persona. Muchas usuarias notan cambios en las primeras 2–4 semanas de uso continuado. Para obtener los mejores resultados, recomendamos un uso constante de al menos 60 días.'
}, {
  question: '¿Es un medicamento?',
  answer: 'No. Trimora es un complemento alimenticio. No es un medicamento ni sustituye tratamiento médico. Si tienes alguna condición de salud, consulta con tu médico antes de comenzar cualquier suplementación.'
}, {
  question: '¿Cómo debo usarlo?',
  answer: 'Toma la dosis recomendada diariamente, preferiblemente con agua antes de las comidas principales. Consulta el etiquetado del producto para las instrucciones específicas de dosificación.'
}, {
  question: '¿Tiene efectos secundarios?',
  answer: 'Trimora está formulado con ingredientes naturales seleccionados por su perfil de seguridad. Si tienes alguna condición médica, estás embarazada, en período de lactancia o tomas medicación, consulta con tu médico antes de usarlo.'
}, {
  question: '¿Cómo funciona la garantía?',
  answer: 'Tienes 90 días desde la compra para solicitar el reembolso completo si no estás satisfecha/o. Sin preguntas. Simplemente contáctanos por email y procesaremos tu devolución en un plazo de 5–7 días hábiles.'
}];
interface FAQItemProps {
  item: FAQItem;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItemComponent({
  item,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-border rounded-xl overflow-hidden" data-id="element-62">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 sm:p-6 text-left bg-card hover:bg-muted transition-colors duration-150" aria-expanded={isOpen} data-id="element-63">
        <span className="font-semibold text-foreground text-base sm:text-lg pr-4" data-id="element-64">
          {item.question}
        </span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-65" /> : <ChevronDownIcon className="w-5 h-5 text-muted-foreground flex-shrink-0" data-id="element-66" />}
      </button>
      {isOpen && <div className="px-5 sm:px-6 pb-5 sm:pb-6 bg-card border-t border-border" data-id="element-67">
          <p className="text-muted-foreground leading-relaxed pt-4" data-id="element-68">
            {item.answer}
          </p>
        </div>}
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-background py-16 sm:py-24" data-id="element-69">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="text-center mb-12" data-id="element-71">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-72">
            Preguntas Frecuentes
          </h2>
          <p className="mt-3 text-muted-foreground text-lg max-w-xl mx-auto" data-id="element-73">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3" data-id="element-74">
          {faqs.map((faq, index) => <FAQItemComponent key={index} item={faq} isOpen={openIndex === index} onToggle={() => handleToggle(index)} data-id="element-75" />)}
        </div>
      </div>
    </section>;
}